<script>
  import { store } from '$client';
  import { page } from '$app/stores';
  export let type = 'green';
  export let title = 'Отправить заявку';
  export let action = '#form';
  export let attributes = {};
  const attr = { class: 'footer-btn-variant push-button', ...attributes };
</script>

{#if action}
  {#if typeof action === 'object'}
    <button class="push-button" data-type={type} {...attr} on:click={() => store.modal.set(action.data.id)}
      >{title}</button>
  {:else if typeof action === 'function'}
    <button class="push-button" data-type={type} {...attr} on:click={action}>{title}</button>
  {:else if typeof action === 'string' && !action.includes($page.url.origin) && action.includes('http')}
    <a rel="nofollow" target="_blank" data-type={type} {...attr} href={action}>{title}</a>
  {:else}
    <a data-type={type} {...attr} href={action}>{title}</a>
  {/if}
{/if}

<style lang="scss">
  button[data-type='green'],
  a[data-type='green'] {
    color: #2c333c;
    background: #22eaac;
  }

  button[data-type='transparent-black'],
  a[data-type='transparent-black'] {
    color: #2c333c;
    border: 2px solid #2c333cbf;
  }

  button[data-type='transparent-white'],
  a[data-type='transparent-white'] {
    color: #fff;
    border: 2px solid #f4f4f499;
  }

  :global(.footer-btn-variant) {
    gap: 10px;
    padding: 18px 40px;
    font-weight: 600;
    font-size: 16px;
    font-family: Vela Sans;
    line-height: 140%;
    white-space: nowrap;
    border-radius: 5px;

    @media only screen and (max-width: 1199.98px) {
      padding: 12px 25px;
    }

    @media only screen and (max-width: 470.98px) {
      padding: 12px 20px;
    }

    @media only screen and (max-width: 350.98px) {
      padding: 12px 16px;
      font-size: 14px;
    }
  }
</style>
